import React, { useEffect, useState, useContext } from 'react';
import {RestFetcher} from '../helpers/RestFetcher'
import { SocketContext } from '../components/SocketContext';
import { loadSpriteSheet } from '../helpers/SpriteUtil';

let players = undefined;

const PlayerList = ({room}) => {
    const socket = useContext(SocketContext);
    const [players, setPlayers] = useState([]);
    const [sprites, setSprites] = useState([]);

    const fetchPlayers = async () => {
        const fetcher = new RestFetcher();
        let fetchedPlayers = await fetcher.fetchPlayers(room);
        console.log("Players " + players.length);
        // Sort players by points in descending order
        fetchedPlayers = fetchedPlayers.sort((a, b) => b.points - a.points);
        setPlayers(fetchedPlayers); // Update state with fetched players
    };

    console.log('PlayerList room name ' + room);

    useEffect(() => {

        if (sprites.length === 0) {
            loadSpriteSheet('bigfaces3.png', 275, 375, 3, 3).then((sprites) => {
                setSprites(sprites);
            }); 
        }
        // Fetch players on initial render
        fetchPlayers();

        // Set up socket event listener
        socket.on('plchg', () => {
            console.log('Players changed');
            fetchPlayers();
        });

        // Clean up the event listener on component unmount
        return () => {
            socket.off('plchg');
        };
    }, [sprites]); // Dependency array should include room to re-fetch if room change

    return (
        <div className="playerlist">
        {players &&
            <ul>
                {players.map((playerItem, index) => (
                    <li key={(playerItem.id)}>{playerItem.name + ' ' + playerItem.points + ' pts'}
                        <img src={sprites[playerItem.sprite]} height="70" />
                    </li>
                ))}
            </ul>
        }
        </div>
    );
};

export default PlayerList;